import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from "vue-router"
import { i18n } from "@/utils/i18n/index"
import { getToken } from "@/utils"
import { getOpBelong } from "@/data/permission"
import { whiteRoutes, constantRoutes, dynameicRoutes, errRoute } from "./routerMap"
import { UserInfoType, useUserInfo } from "@/store"
import { cloneDeep } from "lodash-es"
import { log } from "console"
import { getCurrentRegion } from "@/utils/storage"
export type RowMeta = {
  meta: {
    title: string
    hidden?: boolean
    icon?: string
  }
  children?: Array<RowMeta>
} & RouteRecordRaw

const router = createRouter({
  history: createWebHashHistory(),
  routes: [...whiteRoutes, ...constantRoutes]
})

const filterAsyncRoutes = (routes: Array<RowMeta>, userInfo: UserInfoType) => {
  const routerData = cloneDeep(routes)
  console.log("routerDatarouterData", routerData)
  const region = getCurrentRegion()
  // console.log("regionregion", region)
  if (region === "cn") {
    routerData[0].children = routerData[0].children?.filter((item) => item.name !== "billing")
    // 2. 针对 message 子路由过滤 msgBilling
    const messageMenu = routerData[0].children?.find((item) => item.name === "message")
    if (messageMenu && messageMenu.children) {
      messageMenu.children = messageMenu.children.filter((subItem) => subItem.name !== "msgBilling")
    }
  }
  if (userInfo?.is_main) {
    routerData[0].redirect = "/operations"
    return routerData
  } else {
    //获取有权限菜单名数组
    const menuArr = getOpBelong(userInfo?.permissions.map((item) => item.toString())) || []
    menuArr?.push(["system", "profile", false])
    menuArr?.push(["message", "msgSystem", false])
    menuArr?.push(["message", "msgAlarm", false])

    //过滤一级菜单
    const menus = routerData[0].children!.filter((routeItem) => {
      return menuArr?.find((menuItem) => menuItem[0] == routeItem.name)
    })
    //过滤二级级菜单
    menus?.map((menu) => {
      if (menu.children) {
        menu.children = menu.children.filter((subMenu) => {
          return menuArr?.find((menuItem) => menuItem[1] == subMenu.name)
        })
      }
    })

    // menus?.forEach((menu) => {
    //   if (menu.children) {
    //     menu.children = menu.children.filter((subMenu) => {
    //       const isDeviceOverview = subMenu.name === "deviceoverview"
    //       if (isDeviceOverview) {
    //         // deviceoverview 只有 is_main 才显示
    //         return userInfo?.is_main
    //       }
    //       return menuArr?.find((menuItem) => menuItem[1] === subMenu.name)
    //     })
    //   }
    // })

    routerData[0].children = menus
    const hasControlpanel = menuArr.find((item) => item[1] == "controlpanel")
    if (hasControlpanel) {
      routerData[0].redirect = "/operations"
    } else {
      routerData[0].redirect = "/system"
    }

    return routerData || constantRoutes
  }
}

const whiteNames = whiteRoutes.map((item) => item.name)

router.beforeEach(async (to, from, next) => {
  window.$loading.start()
  const token = getToken()
  const userStore = useUserInfo()
  if (whiteNames.includes(to.name as string)) {
    return next()
  }
  if (!token) {
    return next("/login")
  }

  if (userStore.menuList.length == 0) {
    await userStore.getUserInfo()
    await userStore.getMsgCount()

    const menus = filterAsyncRoutes(dynameicRoutes, userStore.userInfo as UserInfoType)
    router.removeRoute("index")
    menus.map((route) => {
      router.addRoute(route)
    })
    if (router.hasRoute("notFound")) {
      router.removeRoute("notFound")
    }
    router.addRoute(errRoute)

    userStore.setMenuList(menus)

    const redirectPath = menus[0].redirect as string
    if (from.path == "/") {
      const operations = menus[0].children?.find((path) => path.name == "operations")
      const dashboard = operations?.children?.find((item) => item.name == "dashboard")
      const controlpanel = operations?.children?.find((item) => item.name == "controlpanel")

      if (dashboard) {
        return next({ path: dashboard.path, query: to.query, replace: true })
      } else if (controlpanel) {
        return next({ path: controlpanel.path, query: to.query, replace: true })
      } else {
        return next({ path: "/system/profile", query: to.query, replace: true })
      }
    }
    if (from.name == "login") {
      return next({ path: redirectPath, query: to.query, replace: true })
    } else {
      return next({ ...to, replace: true })
    }
  }
  return next()
})

router.afterEach((to) => {
  window.$loading.finish()
  document.title = `${to.meta.title}`
})

router.onError((error) => {
  console.log(error)
})

export default router
